export default __webpack_public_path__ + "static/media/alfie-img.5a54050f.png";